import React, { Component } from "react";
import { connect } from "react-redux";
import StoreNav from "./store-nav.component";
import StoreService from "../services/store.service";
import { buildQualtricsReturnUrl, getUserGroup, isGreenTheme } from "../helpers/experiment";

const DELIVERY_FEE = 2.95;

class StoreBasket extends Component {
  constructor(props) {
    super(props);
    this.currentUser = props.user;
    this.state = {
      items: [],
      order: null,
      loading: true,
      error: null,
      qualtricsReturnUrl: "",
    };
  }

  componentDidMount() {
    this.refreshBasket();
    StoreService.getQualtricsReturnUrl()
      .then((url) => this.setState({ qualtricsReturnUrl: url }))
      .catch(() => {});
  }

  refreshBasket() {
    StoreService.getBasket(this.currentUser.username)
      .then((response) => {
        this.setState({ items: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  handleQuantityChange(item, delta) {
    const newQuantity = item.quantity + delta;
    StoreService.updateBasketItem(this.currentUser.username, item.id, newQuantity)
      .then(() => this.refreshBasket())
      .catch((error) => this.setState({ error: error.message }));
  }

  handleRemove(item) {
    StoreService.logAction(this.currentUser.username, `store-remove-from-basket-${item.productId}`);
    StoreService.removeBasketItem(this.currentUser.username, item.id)
      .then(() => this.refreshBasket())
      .catch((error) => this.setState({ error: error.message }));
  }

  handleCheckout() {
    StoreService.logAction(this.currentUser.username, "store-click-checkout");
    StoreService.checkout(this.currentUser.username)
      .then((response) => {
        this.setState({ order: response.data, items: [] });
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  }

  render() {
    const { items, order, loading, error } = this.state;
    const subtotal = items.reduce((sum, item) => sum + item.lineTotal, 0);
    const total = subtotal + DELIVERY_FEE;
    const themeClassName = isGreenTheme(getUserGroup()) ? "store-theme-green" : undefined;

    if (order) {
      return (
        <div id="store-page" className={themeClassName}>
          <StoreNav basketCount={0} showBack={true} />
          <div className="store-content">
            <div className="store-order-confirmation">
              <div className="store-title">Order confirmed!</div>
              <div>Order #{order.id}</div>
              {order.items.map((oi, idx) => (
                <div key={idx} className="store-order-line">
                  {oi.quantity} x {oi.productName} — £{oi.lineTotal.toFixed(2)}
                </div>
              ))}
              <div className="store-order-line">Subtotal: £{order.subtotal.toFixed(2)}</div>
              <div className="store-order-line">Delivery fee: £{order.deliveryFee.toFixed(2)}</div>
              <div className="store-basket-total">Total: £{order.totalPrice.toFixed(2)}</div>
              <a
                className="store-button store-return-qualtrics"
                href={buildQualtricsReturnUrl(this.currentUser.username, this.state.qualtricsReturnUrl)}
              >
                Return to Qualtrics
              </a>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div id="store-page" className={themeClassName}>
        <StoreNav basketCount={items.reduce((sum, item) => sum + item.quantity, 0)} showBack={true} />
        <div className="store-content">
          <div className="store-title">Your basket</div>
          {loading && <div className="store-loading">Loading...</div>}
          {error && <div className="alert alert-danger" role="alert">{error}</div>}
          {!loading && items.length === 0 && <div className="store-empty-basket">Your basket is empty.</div>}
          {!loading && items.length > 0 && (
            <div className="store-basket-list">
              {items.map((item) => (
                <div key={item.id} className="store-basket-item">
                  <img
                    className="store-basket-item-image"
                    src={`/${item.imageFilename}`}
                    alt={item.productName}
                  />
                  <div className="store-basket-item-name">{item.productName}</div>
                  <div className="store-quantity-selector">
                    <button type="button" onClick={() => this.handleQuantityChange(item, -1)}>-</button>
                    <span>{item.quantity}</span>
                    <button type="button" onClick={() => this.handleQuantityChange(item, 1)}>+</button>
                  </div>
                  <div className="store-basket-item-total">£{item.lineTotal.toFixed(2)}</div>
                  <button
                    type="button"
                    className="store-remove-button"
                    onClick={() => this.handleRemove(item)}
                  >
                    Remove
                  </button>
                </div>
              ))}

              <div className="store-order-line">Subtotal: £{subtotal.toFixed(2)}</div>
              <div className="store-order-line">Delivery fee: £{DELIVERY_FEE.toFixed(2)}</div>
              <div className="store-basket-total">Total: £{total.toFixed(2)}</div>
              <div className="store-checkout-row">
                <button
                  type="button"
                  className="store-button"
                  onClick={() => this.handleCheckout()}
                >
                  Checkout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}

export default connect(mapStateToProps)(StoreBasket);
